<div>
  <video autoplay controls>
    <source src="https://d3azfb2wuqle4e.cloudfront.net/video/user_uploads/2328649/authoring/Teacher+-+E-Assessment+System+Walkthrough/1686773656820/Teacher+-+E-Assessment+System+Walkthrough.mp4.webm" 
            type="video/webm"
            >
  </video>
</div>